import "./Menubar.css";
import { useState } from "react";
import { MenuOutlined } from "@ant-design/icons";

import AboutModal from "../../pages/home-page/components/about-modal/AboutModal";
import ContactModal from "../../pages/home-page/components/contact-modal/ContactModal";
import HelpModal from "../../pages/home-page/components/help-modal/HelpModal";

const Menubar = ({ options }) => {
  const [open, setOpen] = useState(false);
  const [activeModal, setActiveModal] = useState(null);

  const closeModal = () => setActiveModal(null);

  return (
    <>
      <div className="home-menu-wrapper">
        <div className="home-menu-options topbar">
          {/* Desktop */}
          <div className="menu-desktop">
            {options.map((opt) => (
              <div
                key={opt.key}
                className="home-menu-item"
                onClick={() => setActiveModal(opt.key)}
              >
                {opt.title}
              </div>
            ))}
          </div>

          {/* Hamburger */}
          <MenuOutlined className="hamburger" onClick={() => setOpen(!open)} />
        </div>

        {/* Mobile */}
        {open && (
          <div className="menu-mobile">
            {options.map((opt) => (
              <div
                key={opt.key}
                className="mobile-menu-item"
                onClick={() => {
                  setActiveModal(opt.key);
                  setOpen(false);
                }}
              >
                {opt.title}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modals */}
      <AboutModal visible={activeModal === "about"} onCancel={closeModal} />
      <ContactModal visible={activeModal === "contact"} onCancel={closeModal} />
      <HelpModal visible={activeModal === "help"} onCancel={closeModal} />
    </>
  );
};

export default Menubar;
